import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Booked = forwardRef<SVGSVGElement | null, IconFilledProps>(function Booked({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M15.5177 11C15.713 11.1953 15.713 11.5118 15.5177 11.7071L11.3409 15.8839C11.2003 16.0245 11.0095 16.1036 10.8106 16.1036C10.6117 16.1036 10.4209 16.0245 10.2803 15.8839L8.60348 14.2071C8.40822 14.0118 8.40822 13.6953 8.60348 13.5L8.95703 13.1464C9.15229 12.9512 9.46888 12.9512 9.66414 13.1464L10.8106 14.2929L14.457 10.6464C14.6523 10.4512 14.9689 10.4512 15.1641 10.6464L15.5177 11Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8 3.5C8 2.67157 8.67157 2 9.5 2H14.5C15.3284 2 16 2.67157 16 3.5V4H18C19.6569 4 21 5.34315 21 7V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V7C3 5.34315 4.34315 4 6 4H8V3.5ZM9.5 3.5H14.5V5.5H9.5V3.5ZM8 5.5H6C5.17157 5.5 4.5 6.17157 4.5 7V19C4.5 19.8284 5.17157 20.5 6 20.5H18C18.8284 20.5 19.5 19.8284 19.5 19V7C19.5 6.17157 18.8284 5.5 18 5.5H16C16 6.32843 15.3284 7 14.5 7H9.5C8.67157 7 8 6.32843 8 5.5Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M14.5034 1.99976C15.0517 1.99976 15.4978 2.44124 15.4993 2.98951C15.5012 3.65892 15.4989 4.32843 15.4966 4.9979C15.496 5.16412 15.4954 5.33033 15.4949 5.49654C15.4933 6.04882 15.0454 6.49654 14.4932 6.49654H9.50009C8.9478 6.49654 8.50007 6.04948 8.50006 5.49719L8.5 2.99416C8.5 2.44266 8.94661 1.99976 9.49811 1.99976H14.5034Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 19V6C3 4.89543 3.89543 4 5 4H6.5C7.05228 4 7.5 4.44772 7.5 5V6.5C7.5 7.05228 7.94772 7.5 8.5 7.5H15.5C16.0523 7.5 16.5 7.05228 16.5 6.5V5C16.5 4.44772 16.9477 4 17.5 4H19C20.1046 4 21 4.89543 21 6V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19ZM15.5172 11C15.7125 11.1953 15.7125 11.5118 15.5172 11.7071L11.3404 15.8839C11.1998 16.0245 11.009 16.1036 10.8101 16.1036C10.6112 16.1036 10.4204 16.0245 10.2798 15.8839L8.60299 14.2071C8.40773 14.0118 8.40773 13.6953 8.60299 13.5L8.95654 13.1464C9.1518 12.9512 9.46839 12.9512 9.66365 13.1464L10.8101 14.2929L14.4565 10.6464C14.6518 10.4512 14.9684 10.4512 15.1637 10.6464L15.5172 11Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'booked-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Booked;
